














































































/** @format */

import { Vue, Component, Watch } from 'vue-property-decorator';
import toTree, { ITreeNode } from '@root/utils/to-tree';
import { IOrgDep, getDataVConfig, editDataVConfig } from '@/api/system-management';
import { Action } from 'vuex-class';
import { getOrgDepList, getUserId } from '@/api/system-management/index';
import EditableTree from '@/components/data-layout/editable-tree.vue';
import { getOrgTree } from '@/api/login-parking';
//import RightScreen from './components/right-screen.vue'
import RightScreen from '@/views/all-screen/index.vue';
import value from '*.json';
export interface IForm {
  datavConfig: string;
}
@Component({
  components: {
    EditableTree,
    RightScreen
  }
})
export default class ScreenMonitor extends Vue {
  screenUrl = window.VUE_APP_SERVER_CONFIG.META.screenUrl || '';

  orgDepTree: ITreeNode<any>[] = [];
  orgDepName = '';
  // 机构选择树展开内容项
  checkedKeys = '';
  orgDepTreeFirstKeys: any[] = [];
  @Action('organizations/fetchUserOrg')
  fetchUserOrg(params?: { force: boolean }) {} // 获取组织机构信息
  // 左右栏配置
  get flexColumns() {
    return [
      {
        id: 'tree',
        hiddenHeader: true,
        width: '300px',
        padding: '20px'
      },
      {
        id: 'screenMonitor',
        hiddenHeader: true,
        padding: '20px 30px 30px'
      }
    ];
  }
  // 查询条件
  orgDepId: string | null = null; // 机构id
  orgDepCode = ''; // 机构编码
  userLoading: boolean = false;
  userId: string = '';
  isFull: boolean = false; //是否全屏
  visible: boolean = false; // 弹框显示;
  form: any = null;
  labelCol = { span: 8 };
  wrapperCol = { span: 12 };
  created() {
    // this.getOrgDepList()
    this.getOrgDepTree();
  }
  async getOrgDepList() {
    if (this.tableLoading) return false;
    try {
      const { status, code, msg, data }: ProjectListPageResponse<IOrgDep> = await getOrgDepList();
      const { datas = [], totalNum = 0 } = data || {};
      // 设置树状图信息
      const orgDepTree = toTree(datas, {
        idProp: 'orgDepId',
        parentProp: 'parentId',
        titleProp: 'orgDepName',
        keyFieldMap: 'value',
        titleFieldMap: 'title'
      }) as any;
      // 树状图第一级元素id
      this.orgDepTree = orgDepTree;
      const orgDepTreeFirstKey = orgDepTree && orgDepTree[0] && orgDepTree[0].key;
      this.checkedKeys = orgDepTreeFirstKey;
      if (orgDepTreeFirstKey) {
        this.orgDepTreeFirstKeys = [orgDepTreeFirstKey];
        this.orgDepName = orgDepTree && orgDepTree[0] && orgDepTree[0].orgDepName;
      }
      await this.getUserOnlyId();
      this.$nextTick(() => {
        // @ts-ignore hack
        this.$refs.fullScreen.initData();
      });
      // console.log('还会往下走么')
    } catch (error) {
      this.$message.error((error && error.msg) || '系统繁忙，请稍后再试');
    }
  }

  async getOrgDepTree() {
    if (this.tableLoading) return false;
    try {
      const { data = [] } = await getOrgTree();
      // const { datas = [], totalNum = 0 } = data || {}
      // 设置树状图信息
      const orgDepTree = toTree(data, {
        idProp: 'id',
        parentProp: 'parentId',
        titleProp: 'name',
        keyFieldMap: 'value',
        titleFieldMap: 'title'
      }) as any;
      // 树状图第一级元素id
      this.orgDepTree = orgDepTree;
      const orgDepTreeFirstKey = orgDepTree && orgDepTree[0] && orgDepTree[0].key;
      this.checkedKeys = orgDepTreeFirstKey;
      // console.log('this.checkedKeys ', this.checkedKeys)
      if (orgDepTreeFirstKey) {
        this.orgDepTreeFirstKeys = [orgDepTreeFirstKey];
        this.orgDepName = orgDepTree && orgDepTree[0] && orgDepTree[0].name;
      }
      await this.getUserOnlyId();
      this.$nextTick(() => {
        // @ts-ignore hack
        this.$refs.fullScreen.initData();
      });
    } catch (error) {
      this.$message.error((error && error.msg) || '系统繁忙，请稍后再试');
    }
  }
  onSelect(selectedKeys: string[], node: { selected: any; node: { title: string } }) {
    if (!node.selected) return;
    this.checkedKeys = selectedKeys[0];
    this.orgDepName = node.node.title;
    this.$nextTick(() => {
      // @ts-ignore hack
      this.$refs.fullScreen.initData();
    });
  }
  screenHeight = 0;
  mounted() {}
  destroyed() {
    if (this.$refs.fullScreen) {
      // @ts-ignore hack
      this.$refs.fullScreen.clearAllTimer();
    }
  }
  //
  refresh() {
    this.$nextTick(() => {
      // @ts-ignore hack
      this.$refs.fullScreen.initData();
    });
  }
  //获取用户Id
  async getUserOnlyId() {
    try {
      this.userLoading = false;
      const { data } = await getUserId();
      this.userId = data;
    } catch (e) {
      console.log(e);
    } finally {
      this.userLoading = true;
    }
  }
  //全屏
  async fullScreen() {
    await this.getConfigDetail();
    const link =
      window.origin + `/#/all-screen?userId=${this.userId}&orgDepId=${this.checkedKeys}&orgDepName=${this.orgDepName}`;
    window.open(link);
  }
  //全屏链接设置
  async fullScreenConfig() {
    await this.getConfigDetail();
    this.visible = true;
    this.initForm();
  }
  async onSubmit() {
    this.form.validateFields(async (err: boolean, values: IForm) => {
      if (!err) {
        try {
          const { datavConfig, ...rest } = this.formData;
          const json = { ...rest, datavConfig: values.datavConfig };
          await editDataVConfig(json);
          this.$message.success('设置成功');
        } catch (e) {
          console.log(e);
          this.$message.success((e && e.msg) || '设置失败');
        }
      } else {
        console.log(err);
      }
    });
    this.onCancel();
  }
  onCancel() {
    this.visible = false;
  }
  //初始化
  initForm() {
    const { datavConfig } = this.formData;
    console.log('datavConfig', datavConfig);
    this.form = this.$form.createForm(this, {
      mapPropsToFields: () => {
        return {
          datavConfig: this.$form.createFormField({
            value: datavConfig || '00'
          })
        };
      }
    });
  }
  formData: any = {};
  //获取全局配置详情
  async getConfigDetail() {
    try {
      const { data } = await getDataVConfig();
      this.formData = data;
    } catch (e) {
      console.log(e);
    }
  }
}
